// ============================================================================
// Learner display preferences (spec §14.2). Thin selectors over the profile in
// the store so views can gate optional UI (romanization, on-screen keyboard)
// without each reaching into state directly.
// ============================================================================

import { getState } from './state/store.js';

/** Romanization is a crutch — hidden unless the learner opts in (default off). */
export function romanizationOn() {
  return !!getState().profile?.show_romanization;
}

/** On-screen Hangul keyboard shown by default unless the learner turns it off. */
export function keyboardOn() {
  const v = getState().profile?.show_onscreen_keyboard;
  return v == null ? true : !!v;
}
